var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tjhb_left_bottom"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"tjhb_item",on:{"click":function($event){return _vm.goDetail(item.id,1)}}},[_c('p',{staticClass:"line-2"},[_vm._v(_vm._s(item.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }